import React, { useState, useEffect, createContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Preloader from './components/Preloader';
import Home from './pages/Home/Home';
import NotFound from './shared/NotFound/NotFound';
import X from './pages/X/X';

export const InitializeContext = createContext(null as any);

function App() {
  const [loading, setLoading] = useState<boolean>(false);
  const [theme, setTheme] = useState<boolean>(false);
  const [scrollY, setScrollY] = useState<number>(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollY(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY]);

  useEffect(() => {
    setTheme(JSON.parse(window.localStorage.getItem("thKironPortfolio") || false as any));
  }, []);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3500);
  }, []);

  useEffect(() => {
    if (scrollY === 0) {
      document.title = "Toufiq Hasan Kiron";
    }
  }, [scrollY]);

  const toggleTheme = () => {
    setTheme(!theme);
    window.localStorage.setItem("thKironPortfolio", !theme as any);
  };

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
  }, []);

  return (
    <div data-theme={theme ? 'dark' : 'light'} className="bg-base-100 duration-300">
      <InitializeContext.Provider value={{ toggleTheme, theme, scrollY }}>
        {
          loading ? (
            <Preloader />
          ) :
            (
              <>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/x" element={<X />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster />
              </>
            )
        }
      </InitializeContext.Provider>
    </div>
  );
}

export default App;
